import React from 'react';

export default function Pagination({ page, setPage, total, perPage }) {
  const pages = Math.max(1, Math.ceil(total / perPage));
  const arr = Array.from({ length: pages }).map((_, i) => i + 1);
  return (
    <div className="flex items-center justify-center gap-2 mt-6">
      <button onClick={() => setPage(Math.max(1, page-1))} className="px-3 py-1 rounded pagination-btn">‹</button>
      {arr.map(n => (
        <button key={n} onClick={() => setPage(n)} className={`px-3 py-1 rounded pagination-btn ${n===page ? 'active text-white' : 'bg-white border'}`}>{n}</button>
      ))}
      <button onClick={() => setPage(Math.min(pages, page+1))} className="px-3 py-1 rounded pagination-btn">›</button>
    </div>
  );
}
